module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Heavy-20a0e6bb11ac3a7fc85a9bfdce5bf257.svg";